module.controller(
    'clientSiteCtrl',
    [ '$scope', '$rootScope', '$state', 'clientService', 'alertService', 
        function($scope, $rootScope, $state, clientService, alertService) {

    		$scope.idClient = $state.params.idClient;
            $scope.sites = [];
            $scope.loading = false;
            $scope.filter = {};
            $scope.pagination = {
                    current : 1,
                    total : 0
                };

                      
            $scope.clearFilters = function(){
                $scope.filter = {};
            };
            
            
            /**
             *
             * @param idUser
             */
            $scope.search = function(page) {
                $scope.loading = true;
                
                page = page == undefined ? 1 : page;
                $scope.pagination.current = page;

                var filter = {};
                filter.offset = (page - 1) * $rootScope.pageSize;
                filter.limit = $rootScope.pageSize;
                filter.visible = $scope.filter.visible;

                if($scope.filter.name){
                    filter.name = $scope.filter.name;
                }
                
                clientService.searchSites($scope.idClient, filter).then(function(response) {
                    $scope.loading = false;
                    var result = response.getData();
                    $scope.sites = result.results;
                    $scope.pagination.total = result.totalRegisters;
                }, function(response) {
                    $scope.loading = false;
                });
            };

            $scope.remove= function(idClient, idSite){
            	var site = $scope.sites.find(function(site){ return site.id == idSite; })
                alertService.showSwtQuestion('Eliminar el punto "'+ site.name +'"', function() {
                    $scope.loading = true;

                    clientService.removeClientSite(idClient, idSite).then(function(response) {
                        $scope.loading = false;
                        $scope.search(1);
                        alertService.showSuccess('Punto eliminado satisfactoriamente');
                    }, function(response) {
                        $scope.loading = false;
                    });
                });
            }
            
            $scope.search(1);
            
            $scope.getContactSummary = function(site){
            	if(site.contact){
            		return site.contact.name + '(' + site.contact.email + ')'; 
            	}
            	else{
            		return 'Sin contacto';
            	}
            };

        } ]);


